import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import '@maersk-global/mds-components-core';

@Component({
  selector: 'pagination',
  templateUrl: 'pagination.component.html',
  styleUrls: ['pagination.component.scss'],
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaginationComponent implements OnInit {
  @Input() currentPage: number = 0;
  @Input() visiblePages: number = 0;
  @Input() totalPages: number = 0;
  @Input() itemsPerPage: number = 0;
  @Input() totalItems: number = 0;
  @Input() pageChanged: (event: Event) => void = (e) => {};

  message?: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.updateMessage();
  }
  private updateMessage() {
    const floor = this.currentPage - 1;
    const currentPageItems =
      this.totalPages === 0
        ? 0
        : this.currentPage === this.totalPages
        ? this.totalItems % this.itemsPerPage || this.itemsPerPage
        : this.itemsPerPage;

    this.message = `Showing ${
      currentPageItems < this.itemsPerPage && this.currentPage === 1
        ? currentPageItems
        : floor * this.itemsPerPage + 1
    } - ${floor * this.itemsPerPage + currentPageItems} of ${this.totalItems}`;
  }

  ngOnInit(): void {
    const floor = this.currentPage - 1;
    const currentPageItems =
      this.totalPages == 0
        ? 0
        : this.currentPage == this.totalPages
        ? this.totalItems % this.itemsPerPage || this.itemsPerPage
        : this.itemsPerPage;
    this.message = `Showing ${
      currentPageItems < this.itemsPerPage && this.currentPage === 1
        ? currentPageItems
        : floor * this.itemsPerPage + 1
    } - ${floor * this.itemsPerPage + currentPageItems} of ${this.totalItems}`;
  }
}
